import React, { useState } from "react";
import { connect } from "react-redux";
import { useFormContext } from "react-hook-form";

import { PropertyType } from "../../../../assets";
import PropertyTypesIconMapping from "../../../../assets/icons/PropertyTypesIconMapping";
import { EMPTY_STRING } from "../../../../constants";
import { getSelectOptions } from "../../../../shared/utility";
import CustomSelect from "../../../../shared/components/select/CustomSelect";
import SliderControls from "../../../../shared/components/slider/SliderControls";

const PropertyTypes = (props) => {
  const { allPropertyTypes } = props;

  const {
    setValue,
    getValues,
    formState: { errors },
    trigger,
  } = useFormContext();

  const [currentPage, setCurrentPage] = useState(1);

  const toggleSelectProperty = (property) => {
    const selected = getValues("propertyTypeIds") ?? [];
    setValue(
      "propertyTypeIds",
      selected.includes(property.id)
        ? selected.filter((id) => id !== property.id)
        : [...selected, property.id]
    );
    trigger("propertyTypeIds");
  };
  return (
    <div className="create-form-card">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <div className="form-card-heading">
          <img src={PropertyType} alt={EMPTY_STRING} />
          Select Property Type
        </div>
        <CustomSelect
          options={getSelectOptions(allPropertyTypes, "title", "id")}
          isMulti
          className="w-auto types-select"
          name="propertyTypeIds"
          showError={false}
          isClearable={false}
          defaultStyle={false}
        />
      </div>
      <div className="options">
        {allPropertyTypes
          .slice((currentPage - 1) * 10, currentPage * 10)
          .map((option, index) => (
            <div
              key={index}
              className={`option ${
                (getValues("propertyTypeIds") ?? []).includes(option.id)
                  ? "selected-option"
                  : EMPTY_STRING
              }`}
              onClick={() => toggleSelectProperty(option)}
            >
              <img
                alt={EMPTY_STRING}
                src={PropertyTypesIconMapping[option.icon]}
                className="create-listing-property-types-icon"
              />
              {option.title}
            </div>
          ))}
      </div>
      {errors.propertyTypeIds && (
        <div className="error mt-2 w-100">{errors.propertyTypeIds.message}</div>
      )}
      <div className="slider-controls">
        <SliderControls
          className="mt-2 mb-1"
          length={Math.ceil(allPropertyTypes.length / 10)}
          changeIndex={(index) => setCurrentPage(index + 1)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allPropertyTypes: state.propertyReducer.allPropertyTypes,
});

export default connect(mapStateToProps, null)(PropertyTypes);
